/* @jsxRuntime automatic */
/* @jsxImportSource @superweb/css */
import {
  useDebouncedState,
  type ComboBoxOption,
  type ComboBoxState,
} from "@superweb/ui";
import { useLocale } from "@superweb/intl";
import { useOnDemandQuery } from "@fleet/api";

import { useMessage } from "#internal/intl";
import { useValidate } from "#internal/utils";
import { FormSuggest } from "#internal/ui";

export type RegionDetailsState = {
  region: ComboBoxState<ComboBoxOption>;
};

export const RegionDetailsFields = ({
  state,
  onChange,
  refId,
}: {
  state: RegionDetailsState;
  onChange: (nextState: RegionDetailsState) => void;
  refId: string;
}) => {
  const locale = useLocale();
  const message = useMessage();
  const { validateComboboxField } = useValidate();

  const debouncedRegionState = useDebouncedState(state.region, 300);

  const { response } = useOnDemandQuery(
    state.region.inputValue.length
      ? {
          url: "/fleet-forms/selfreg/v1/cities/suggest",
          method: "POST",
          body: { query: { text: debouncedRegionState.inputValue } },
          query: { ref_id: refId },
          headers: {
            language: locale.toString(),
            "content-type": "application/json",
          },
        }
      : undefined,
  );

  const citiesOptions =
    response?.status === 200
      ? response.body.cities.map((item) => ({
          label: item.name,
          key: item.region_id.toString(),
        }))
      : [];

  return (
    <FormSuggest
      data={citiesOptions}
      label={message({
        id: "aa28f249-6c3b-4cd7-a7e3-75673293d5cb",
        context: "Forms. Region field",
        default: "Region",
      })}
      state={state.region}
      onChange={(newState) => {
        const errorMessage = validateComboboxField(newState);
        onChange({
          region: {
            ...newState,
            errorMessage,
            errorVisible: Boolean(errorMessage),
          },
        });
      }}
    />
  );
};
